export default __webpack_public_path__ + "img/385dd7cf3727944512b20057b90deeb8.png";